module.exports = __webpack_public_path__ + "img/player_jump_003.fa5c8088.png";